import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-community-trending',
  templateUrl: './community-trending.component.html',
  styleUrls: [
    './../filter-products/filter-products.component.scss',
    './community-trending.component.scss'
  ],
})
export class CommunityTrendingComponent implements OnInit {

  constructor(
    private customerService: CustomerService,
    private commonService: CommonService,
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
  }

  @Output()
  public onViewProducts = new EventEmitter();

  public viewProductDetails(prod) {
    this.onViewProducts.emit(prod)
  }

  public areThereMore = false;

  public onProductsSwiper(swiper) {
    this.areThereMore = !swiper.isEnd;
    this.cdr.detectChanges();
  }
  public onProductSlideChange(swiper) {
    this.areThereMore = !swiper.isEnd;
    this.cdr.detectChanges();
  }

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: "auto",
    pagination: false,
    slidesPerGroup: 2,
    freeMode: true
  };

  //Technology / Cleaner / Pets / Education
  bottomCategories = [
    { name: 'Education', },
    { name: 'Beauty', need: 'Beauty & Grooming' },
    { name: 'TCM', },
    { name: 'Cleaning', },
    { name: 'Pets', },
    { name: 'Plumbing', },
  ];

  public allBottomProducts: {
    currentPage: number,
    data: Array<any>,
    lastPage: number,
    totalCount: number
  } = {
      currentPage: 1,
      data: [],
      lastPage: 1,
      totalCount: 0
    };

  filteredBottomProducts: any = []
  public bottomProductsSubCategory = '';
  public bottomProductsSubCategoryId = null;
  public imgUrl = environment.ImageUrl;

  ngOnInit(): void {
    this.customerService.getAllCommunityProductCategoryList().subscribe((response: any) => {
      response = response.body;
      this.bottomCategories.forEach((row) => {
        const find = response.find((value) => row.need?.toLowerCase()?.trim() == value.name?.toLocaleLowerCase()?.trim() ||
          row.name?.toLowerCase()?.trim() == value.name?.toLocaleLowerCase()?.trim()
        )
        if (find) {
          (row as any).id = find.id
        }
      })
      this.loadProducts(this.bottomCategories[0]);
      this.cdr.detectChanges();
    })
  }

  memberShopProductList: any = []

  public isLoading: boolean = true
  public showtCarousel = true
  public refreshBottomProducts(page: number = 1, resetCarousel = false) {
    if (resetCarousel) {
      this.showtCarousel = false;
      this.cdr.detectChanges();
    }
    if (this.bottomProductsSubCategoryId == null) {
      this.allBottomProducts = {
        currentPage: 1,
        data: [],
        lastPage: 1,
        totalCount: 0
      }
      return
    }

    this.isLoading = true
    this.customerService
      .getMemberShopProductList({
        categoryId: this.bottomProductsSubCategoryId,
        isAdmin: false,
        page: page,
        basedProduct: 'all'
      })
      .subscribe({
        next: (data: any) => {
          data = data.body
          if (data.currentPage === 1) this.allBottomProducts.data = []
          if (data?.data)
            this.allBottomProducts = {
              ...data,
              data: [
                ...this.allBottomProducts.data,
                ...data?.data
              ]
            };
          this.isLoading = false
          this.showtCarousel = true;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false
          console.error(err)
          this.isLoading = false;
          this.showtCarousel = true;
          this.cdr.detectChanges();
        },
      });
  }

  loadProducts(category: any) {
    if (this.bottomProductsSubCategory == category.name) return false;
    this.bottomProductsSubCategory = category.name;
    this.bottomProductsSubCategoryId = category.id;
    this.refreshBottomProducts(1, true);
  }
}
